<template>
  <v-row justify="center" align="center">
    <v-col cols="12" class="pb-0">
      <v-banner icon="mdi-magnify"> Customer Search </v-banner>
    </v-col>
    <v-col cols="12" md="12" sm="12">
      <v-card flat>
        <v-card-text class="pt-0">
          Search By head office or customer account or by name
        </v-card-text>
        <v-card-text>
          <v-autocomplete
            v-model="selectedCustomer"
            :items="items"
            :loading="loading"
            :search-input.sync="search"
            no-filter
            chips
            clearable
            hide-details
            hide-selected
            item-text="name"
            item-disabled="disable"
            item-value="delivery_account_no"
            label="Search for a Customer"
            outlined
          >
            <template v-slot:no-data>
              <v-list-item>
                <v-list-item-title>
                  No
                  <strong>Customer</strong>
                  Found
                </v-list-item-title>
              </v-list-item>
            </template>
            <template v-slot:selection="{ attr, on, item, selected }">
              <v-chip
                v-bind="attr"
                :input-value="selected"
                color="blue darken-2"
                class="white--text"
              >
                {{ `(${item.delivery_account_no}) ${item.name}` }}
              </v-chip>
            </template>
            <template v-slot:item="data">
              <v-list-item-avatar
                :color="data.item.disable ? 'error' : 'indigo'"
                class="text-h5 font-weight-light white--text"
              >
                {{data.item.disable ? 'X' : data.item.name.charAt(0) }}
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title v-text="data.item.name"></v-list-item-title>
                <v-list-item-subtitle
                  v-text="data.item.disable ? data.item.delivery_account_no + ' (On Stop)' : data.item.delivery_account_no"
                ></v-list-item-subtitle>
              </v-list-item-content>
            </template>
          </v-autocomplete>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            :disabled="!selectedCustomer"
            outlined
            color="blue darken-2"
            @click="confirmCustomer()"
          >
            Submit
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import axios from "@/axios";

export default {
  name: "CustomerSearch",
  data() {
    return {
      search: "",
      items: [],
      loading: false,
    };
  },
  computed: {
    selectedCustomer: {
      get() {
        return this.$store.getters.retrieveSelectedCustomer;
      },
      set(val) {
        this.$store.commit("setSelectedCustomer", val);
      },
    },
  },
  watch: {
    search(val) {
      if (val) {
        clearTimeout(this.debounce);
        this.debounce = setTimeout(() => {
          this.customerSearch();
        }, 600);
      }
    },
    // selectedCustomer(val, oldVal) {
    //   if (val != oldVal) {
    //     console.log(val)
    //   }
    // }
  },

  methods: {
    async confirmCustomer() {
      console.log("-- Confirming Customer");
      console.log(this.$route.query);
      //this.$router.push({ name: "OrdersCreate" });
      //let redirect = this.$route.query.dest_name;
      console.log("Redirecting to -- " + this.$route.query.dest_name);
      if (
        this.$route.query.dest_name == "CustomerSearch" ||
        !this.$route.query.dest_name
      ) {
        this.$router.push({ name: "Home" });
      } else {
        this.$router.push({ name: this.$route.query.dest_name });
      }
    },

    async customerSearch() {
      this.loading = true;
      this.items = [];
      let stringPayload = JSON.stringify({
        userId: this.$store.getters.retrieveUser.userNum,
        sessionKey: this.$store.getters.retrieveUser.sessionKey,
        search: this.search,
      });
      const params = new URLSearchParams();
      params.append("params", stringPayload);

      await axios
        .post("admin/search-customer", params)
        .then((response) => {
          if (response.data.success) {
            this.items = [];
            let customerList = response.data.customer_list;
            let allKeys = Object.keys(customerList);
            if (allKeys.length > 0) {
              allKeys.forEach((key) => {
                let headOffice =
                  customerList[key]["headOffice"].delivery_account_no +"-"+
                  customerList[key]["headOffice"].name;
                let obj = { header: headOffice };
                this.items.push(obj);
                let allHeadOfficeCustomers = customerList[key]["customers"];
                allHeadOfficeCustomers.forEach((customer) => {
                  if (customer.account_on_stop == "on") {
                    customer.disable = true
                  } else {
                    customer.disable = false
                  }
                  this.items.push(customer);
                });
              });
            }
          }
        })
        .catch((err) => {
          console.log(err);
        });

      this.loading = false;
    },
  },
};
</script>

<style lang="sass" scoped>
</style>